import Modal from './Modal';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import ModalFormGrid from './ModalFormGrid';
import ModalHeader from './ModalHeader';
import ModalMessage from './ModalMessage';
import ModalNotice from './ModalNotice';
import ModalTitle from './ModalTitle';
import Overlay from './Overlay';

export default Object.assign(Modal, {
  Header: ModalHeader,
  Body: ModalBody,
  Title: ModalTitle,
  Message: ModalMessage,
  Footer: ModalFooter,
  Overlay: Overlay,
  FormGrid: ModalFormGrid,
  Notice: ModalNotice,
});
